<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

    <!-- Table -->
    <p-table [columns]="cols"
             [value]="products"
             [lazy]="true"
             (onLazyLoad)="handleLazyLoad($event)"
             [paginator]="true"
             [(first)]="first"
             [rows]="rowsPerPage"
             [rowsPerPageOptions]="rowsPerPageOptions"
             [totalRecords]="totalRecords"
             [resizableColumns]="true"
             [columnResizeMode]="'expand'"
             [autoLayout]="true"
             [styleClass]="'p-datatable-striped'"
             [scrollable]="true"
             [scrollHeight]="'flex'">
        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" class="search-input"
                           [(ngModel)]="filter.searchName" (input)="handleFilterChange()"
                           placeholder="Search..." />
                </span>
                <span>
                    <button pButton pRipple type="button" label="Create" class="p-button-success"
                            style="margin-right: 10px;" (click)="handleCreateProductClick()"></button>
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th *ngFor="let col of cols"
                    [pSortableColumn]="col.field"
                    [pSortableColumnDisabled]="col.disableSort"
                    pResizableColumn
                    [style.width]="col.width">
                    {{col.header}}
                    <p-sortIcon *ngIf="sortField===col.field" [field]="col.field"></p-sortIcon>
                </th>
                <th>Action</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product>
            <tr>
                <td class="ui-resizable-column">{{product.Id}}</td>
                <td class="ui-resizable-column">{{product.CreatedAt}}</td>
                <td class="ui-resizable-column">{{product.Name}}</td>
                <td class="ui-resizable-column">{{product.RestaurantName}}</td>
                <td>
                    <a href="{{product.ImageUrl}}" target="_blank">
                        <img src="{{product.ImageUrl}}" width="100" />
                    </a>
                </td>
                <td>
                    <span class="action-icon-svg" (click)="handleEditProductClick(product)">
                        <img src="../Content/xpress-app/images/svg/icon_edit.svg" />
                    </span>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="paginatorleft" let-state>
            <div *ngIf="products.length > 0" style="padding-left: 10px">
                Displaying {{first + 1}} - {{first + products.length}} of {{totalRecords}}
            </div>
        </ng-template>
    </p-table>
</div>

<edit-food-product *ngIf="showEditProductPopup"
                   [productId]="editProductId"
                   [restaurants]="restaurants"
                   [onHide]="handleEditProductPopupHide"
                   [onSave]="handleEditProductPopupSave"></edit-food-product>

<p-toast position="top-right"></p-toast>
